import { defineNuxtPlugin, useRoute } from '#imports';
import { useAuthStore } from '~/stores/auth';

export default defineNuxtPlugin({
  name: 'auth-bootstrap',
  async setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const publicRoutes = ['/login', '/forgot-password', '/api/auth/callback'];
    const isSearchPublicRoute = route.path.startsWith('/search/animals/');
    const isPrivacyPolicyPublicRoute = route.path.startsWith('/privacypolicy');
    const isPublicRoute =
      publicRoutes.includes(route.path) ||
      isSearchPublicRoute ||
      isPrivacyPolicyPublicRoute;

    if (!isPublicRoute && authStore.token) {
      await authStore.fetchUser();
    }
  },
});
